<template>
  <div v-if="location">
    <card class="mb-4" shadow noBody>
      <template v-slot:header>
        <div class="bg-white border-0">
          <div class="row align-items-top">
            <div class="col-8">
              <h3 class="mb-0">Location Leadership</h3>
            </div>
            <div class="col-4 text-right">
              <div v-if="!edit">
                <a href="#" @click.prevent="toggleEdit" class="text-sm">edit</a>
              </div>
              <div v-else>
                <a href="#" @click.prevent="toggleEdit" class="text-sm"
                  >cancel</a
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="table-responsive">
        <!-- readonly -->
        <div v-if="!edit">
          <table class="table tablesorter">
            <tbody>
              <tr
                v-for="role in supportedLeadershipRoles"
                :key="`role-${role.key}`"
              >
                <td class="align-middle" width="100">{{ role.label }}</td>
                <td class="align-middle">
                  <div v-if="leadershipRoles[role.key]">
                    {{ leadershipRoles[role.key] }}
                  </div>
                  <div v-else>
                    <em class="text-sm text-muted"> n/a </em>
                  </div>
                </td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- edit -->
        <form v-else @submit.prevent="saveLeadershipRoles">
          <table class="table tablesorter">
            <tbody class="">
              <tr
                v-for="role in supportedLeadershipRoles"
                :key="`supported-link-${role.key}`"
              >
                <td class="align-middle" width="100">{{ role.label }}</td>
                <td>
                  <input
                    type="input"
                    placeholder=""
                    class="form-control form-control-alternative fw-bold"
                    v-model="inputs[role.key]"
                  />
                </td>
                <td></td>
              </tr>
              <tr>
                <td>
                  <input type="submit" value="Save" class="btn btn-primary" />
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import copy from "copy-to-clipboard";

export default {
  mounted() {
    this.setInputs();
  },
  components: {},
  props: ["location"],
  data() {
    return {
      edit: false,
      inputs: {},
    };
  },
  computed: {
    supportedLeadershipRoles() {
      return [
        { key: "vp", label: "VP" },
        { key: "rdo", label: "RDO" },
        { key: "areaManager", label: "Area Manager" },
        { key: "cityManager", label: "City Manager" },
      ];
    },
    leadershipRoles() {
      return {
        vp: this.location?.vp || "",
        rdo: this.location?.rdo || "",
        areaManager: this.location?.areaManager || "",
        cityManager: this.location?.cityManager || "",
      };
    },
  },
  methods: {
    setInputs() {
      Object.keys(this.leadershipRoles).forEach((role) => {
        this.inputs[role] = this.leadershipRoles[role] || "";
      });
    },
    toggleEdit() {
      this.setInputs();
      this.edit = !this.edit;
    },
    async saveLeadershipRoles() {
      const response = await this.$store.dispatch(
        "callAPI",
        Object.assign(
          {
            action: "updateLocation",
            locationId: this.location.locationId,
          },
          this.inputs
        )
      );
      this.$emit("updated", response.data.data);
      this.edit = false;
    },
    async copyUrl(url) {
      copy(url);
    },
    async openUrl(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss"></style>
